import React, { useContext } from "react";

import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { NavLink } from "react-router-dom";

import Checkout_icon from "../../../../assests/images/cart.svg";

import logoPng from "../../../../assests/images/header_logo.png";
import Auth from "../../../../auth/Auth";
import AppContext from "../../../../shared/AppContext";
import moment from "moment";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function Header() {
  const { companyInfo, cartValue } = useContext(AppContext);
  // let companynamecut;
  // if (companyInfo.name) {
  //   companynamecut = companyInfo.name.slice(0, 10);
  // }


  const BookingDate = moment(Date.parse(new Date())).format("MMM Do YYYY");

  const {pathname} = useLocation();

  return (
    <>
      <header className="custom_header">
        <Navbar
          className="navbar navbar-expand-lg navbar-light mb-3"
          collapseOnSelect
          expand="lg"
        >
          <Navbar.Brand to="/">
            <h4 className="brand_text">{companyInfo.name || ""}</h4>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            {pathname.includes("/passenger-details") ? (
              <div className="text-center w-100">

                <img src={logoPng} alt="" />
              </div>
            ) : (
              <>
                <Nav className="me-auto custom_first_navitem">
                  <div className="custom_first_navitem_navlink">
                    <p className="current_date_text mb-0">{BookingDate}</p>
                  </div>
                </Nav>

                <Nav className="second-collapse_toogle">
                  <NavLink
                    to={`${cartValue.count > 0 ? "/CartDetails/" + Auth.getCompanyID() : `/?id=${Auth.getCompanyHexaID()}`}`}
                    className={`position-relative align-self-center ${cartValue.count > 0 ? "" : "cursor-not-allowed"}`}
                  >
                    <img src={Checkout_icon} alt="Check out icon" />
                    <span className="cart_value">{cartValue.count}</span>
                  </NavLink>
                </Nav>
              </>
            )}
          </Navbar.Collapse>
        </Navbar>
      </header>
    </>
  );
}

export default Header;
